export const EMPLOYEES_RESET_STATE = 'EMPLOYEES_RESET_STATE';
export const EMPLOYEES_CURRENT_ITEM = 'EMPLOYEES_CURRENT_ITEM';

export const EMPLOYEES_REQUEST_LOADING = 'EMPLOYEES_REQUEST_LOADING';
export const EMPLOYEES_REQUEST_SUCCESS = 'EMPLOYEES_REQUEST_SUCCESS';
export const EMPLOYEES_REQUEST_FAILED = 'EMPLOYEES_REQUEST_FAILED';

export const EMPLOYEES_CURRENT_ACTION = 'EMPLOYEES_CURRENT_ACTION';
export const EMPLOYEES_RESET_ACTION = 'EMPLOYEES_RESET_ACTION';